import React from 'react';
import SiteHeader from '../SiteHeader/SiteHeader';
import MobileControls from '../MobileControls/MobileControls';

/**
 * @summary The Header component contains static and dynamic Structure elements. The SiteHeader and SiteNavigation can be customized by passing in props.
 * @see https://github.com/Office-of-Digital-Services/California-State-Web-Template-react/wiki/Structure#header
 * 
 * @example
 * <Header />
 * 
 * @returns {React.ReactElement} Returns the Header structure element.
 */

const Header = () => (
  <header role={'banner'} id={'header'} className={'global-header fixed'}>
    <div id="skip-to-content">
      <a href="#main-content">Skip to Main Content</a>
    </div>
    <div className="utility-header">
      <div className="container">
        <div className="flex-row">
          <div className="social-media-links">
            <div className="header-cagov-logo">
              <a href="https://ca.gov">
                <span className="sr-only">CA.gov</span>
                <span className="ca-gov-logo-svg"></span>
              </a>
            </div>
            <p className="official-tag">
              <span className="desktop-only">Official website of the </span>
              State of California
            </p>
          </div>
          <div className="settings-links">
            <ul className="utility-links">
              <li><a href="https://emsa.ca.gov/contacts">Contact Us</a></li>
              <li><a href="https://emsa.ca.gov/translate/">Translate</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <SiteHeader />
    <MobileControls />
    <div className="navigation-search full-width-nav container">
      <div id="head-search" className="search-container featured-search">
        {/* Removed ActiveSearch component */}
      </div>
      {/* Removed SiteNavigation component */}
    </div>
  </header >
)

export default Header